<template>
    <div id="app" :class="getAppClass" class="no-nav">
        <router-view></router-view>
        <notification-list></notification-list>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    import NotificationList from "./NotificationList";

    export default {
        components: {
            NotificationList,
        },
        computed: {
            ...mapState({
                appClass: state => state.appClass
            }),
            ...mapGetters([
                'getAppClass'
            ]),
        },
    }
</script>

<style scoped>

</style>